/* eslint-disable jsx-a11y/click-events-have-key-events, jsx-a11y/no-noninteractive-element-interactions */
import { forwardRef, useRef, useEffect } from "react";
import styles from "./styles/themes/default.module.scss";

const Option = forwardRef((props, ref) => {
    return (
        <li
            ref={ref}
            role="option"
            tabIndex={-1}
            className={styles.option}
            onClick={props.onClick}
            id={props.id}
            aria-selected={props.active ? "true" : null}
            data-testid="option"
        >
            <span className={styles.text}>{props.children}</span>
        </li>
    );
});

const ActiveOption = (props) => {
    const ref = useRef();
    useEffect(() => {
        if (ref.current) {
            ref.current.focus();
        }
    }, []);
    return <Option active={true} ref={ref} {...props} />;
};

export { Option as default, ActiveOption };
